import React from 'react';
import { WebsiteDesignProps } from './types';
import { Triangle, Circle, Square } from 'lucide-react';
import { Button } from "@/components/ui/button";

const MemphisStyle: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The 80s Studio";

    return (
        <div className="bg-[#fff0f5] min-h-screen font-sans text-black overflow-hidden relative">
            {/* Squiggle Pattern */}
            <div className="absolute top-0 right-0 w-full h-full opacity-30 pointer-events-none z-0">
                <svg width="100%" height="100%">
                    <pattern id="pattern-circles" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
                        <circle cx="20" cy="20" r="2" fill="#000" />
                    </pattern>
                    <rect width="100%" height="100%" fill="url(#pattern-circles)" />
                </svg>
            </div>

            <nav className="p-8 relative z-20 flex justify-between items-center bg-white border-b-4 border-black shadow-[4px_4px_0_0_black]">
                <div className="text-3xl font-black uppercase tracking-tighter italic transform -rotate-2 bg-yellow-300 px-2 border-2 border-black shadow-[2px_2px_0_0_black]">
                    {schoolName}
                </div>
                <div className="flex gap-4">
                    <Button className="bg-cyan-400 text-black border-2 border-black shadow-[4px_4px_0_0_black] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_0_black] rounded-full font-bold uppercase transition-all">
                        Apply Now
                    </Button>
                </div>
            </nav>

            <main className="relative z-10 container mx-auto px-6 py-12">
                 <div className="flex flex-col md:flex-row items-center gap-12">
                     <div className="md:w-1/2">
                         <div className="bg-pink-400 w-16 h-16 rounded-full border-4 border-black mb-6"></div>
                         <h1 className="text-6xl md:text-8xl font-black uppercase leading-[0.85] mb-8">
                             Shape <br/> Your <span className="text-white text-shadow-black">Future</span>
                         </h1>
                         <p className="text-xl font-bold bg-white inline-block border-2 border-black p-4 shadow-[4px_4px_0_0_black]">
                             Bold. Colorful. Unapologetic. Education for the brave.
                         </p>
                     </div>

                     <div className="md:w-1/2 relative">
                         {/* Geometric Shapes */}
                         <div className="absolute top-0 right-10 w-32 h-32 bg-yellow-400 border-4 border-black transform rotate-12 z-0"></div>
                         <div className="absolute bottom-10 left-0 w-40 h-40 bg-cyan-400 rounded-full border-4 border-black z-0"></div>
                         <div className="relative z-10 bg-white border-4 border-black p-4 shadow-[8px_8px_0_0_black]">
                             <img src="https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?q=80&w=2048&auto=format&fit=crop" className="w-full grayscale contrast-125" alt="Student" />
                         </div>
                         <Triangle className="absolute -bottom-8 -right-8 w-24 h-24 text-black fill-black transform rotate-12" />
                     </div>
                 </div>

                 <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-8">
                     <div className="bg-yellow-300 border-4 border-black p-6 shadow-[8px_8px_0_0_black] transform rotate-1">
                         <Square size={40} className="mb-4 fill-white" />
                         <h3 className="text-2xl font-black uppercase">Structure</h3>
                     </div>
                     <div className="bg-pink-300 border-4 border-black p-6 shadow-[8px_8px_0_0_black] transform -rotate-1">
                         <Circle size={40} className="mb-4 fill-white" />
                         <h3 className="text-2xl font-black uppercase">Community</h3>
                     </div>
                     <div className="bg-cyan-300 border-4 border-black p-6 shadow-[8px_8px_0_0_black] transform rotate-1">
                         <Triangle size={40} className="mb-4 fill-white" />
                         <h3 className="text-2xl font-black uppercase">Growth</h3>
                     </div>
                 </div>
            </main>
        </div>
    );
};

export default MemphisStyle;
